import './SubDub.scss'
import icon_back from "../../../../SubUsers/images/back-button.png";
import icon_check from './image/check.png'
import {useEffect, useState} from "react";
import {translateWord} from "../../../../Util/util";

export default function SubDub({
                                   audioTracks,
                                   subtitles,
                                   btn_show_sub_dub_field,
                                   activeAudioTrack,
                                   activeSub,
                                   btn_subtitle,
                                   btn_dubbing,
                                   stop_propogation
                               }) {
                                
    
    return (
        <div className="main_sub_dub" onClick={btn_show_sub_dub_field}>
            <img src={icon_back} className="close_field_player_movie" onClick={btn_show_sub_dub_field}/>
            <div className="parent_sub_dub" onClick={stop_propogation}>
                <div className="parent_sub">
                    <h1 className="title_sub_dub">{translateWord('Dubbing')}</h1>
                    <div className="col_sub_dub">
                        {audioTracks.map((e, i) => {
                            return (
                                <div key={i} className={i == activeAudioTrack ? "card_sub_dub active" : "card_sub_dub"}
                                     onClick={() => btn_dubbing(i)}>
                                    <img src={icon_check} alt=""/>
                                    <span>{e.name}</span>
                                </div>
                            )
                        })}
                    </div>

                </div>
                <div className="parent_dub">
                    <h1 className="title_sub_dub">{translateWord('Subtitle')}</h1>
                    <div className="col_sub_dub">
                        <div className={activeSub == -1 ? "card_sub_dub active" : "card_sub_dub"}
                             onClick={() => btn_subtitle(-1)}>
                            <img src={icon_check} alt=""/>
                            <span>{'Off'}</span>
                        </div>
            
                        {subtitles.map((e, i) => {
                            return (
                                <div key={i} className={activeSub == i ? "card_sub_dub active" : "card_sub_dub"}
                                     onClick={() => btn_subtitle(i)}>
                                    <img src={icon_check} alt=""/>
                                    <span>{e.name}</span>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    )
}